<template>
  <div
    :class="{'hide': disabled}"
    class="compantent-updata-img">
    <el-upload
      name="file"
      :action="uploadDomain"
      :data="data"
      :file-list="imgList"
      :limit="length"
      :disabled="disabled"
      list-type="picture-card"
      :before-upload="beforeUpload"
      :on-success="handleSuccess"
      :on-error="handleError"
      :on-preview="handlePictureCardPreview"
      :on-remove="handleRemove"
      :on-exceed="handleExceed">
      <i class="el-icon-plus"/>
      <div class="el-upload__tip" slot="tip">{{tips}}</div>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible" class="show">
      <img
        width="100%"
        :src="dialogImageUrl">
    </el-dialog>
    <!-- <span class="updata-img-message">限上传{{ length }}张图片， 且文件格式限制jpg/png</span> -->
  </div>
</template>

<script>
import env from '@/configs/env'
// import utils from '@/jslib/dk-utils'
import getQiniuToken from '@/api/common'

export default {
  props: {
    tips: {
      type: String,
      default: ''
    },
    img: {
      type: [String, Array]
      // default: null,
    },
    length: {
      type: Number,
      default: 1
    },
    size: {
      type: Array,
      default: () => [180, 180]
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      uploadDomain: env.qnUploadImgDomain,
      dialogImageUrl: '',
      dialogVisible: false,
      data: {
        token: ''
      }
    }
  },
  // watch: {
  //   img:{
  //     handler(newVal, oldVal){
  //       debugger
  //     },
  //     immediate: true
  //   }
  // },
  computed: {
    imgList() {
      const arr = []
      const type = typeof this.img
      if (type === 'string' && this.img) {
        arr.push({
          url: window.$imgUrl + this.img.replace('/app/img/', '')
        })
      }
      if (Array.isArray(this.img)) {
        this.img.forEach((item) => {
          arr.push({
            url: window.$imgUrl + item.replace('/app/img/', '')
          })
        })
      }
      return arr
    }
  },
  methods: {
    async beforeUpload(file) {
      if (file.type.indexOf('image') === -1) {
        this.$notify({
          title: '警告',
          message: '请上传图片格式！',
          type: 'warning'
        })
        return false
      }
      if (file.type.indexOf('jpg') === -1 && file.type.indexOf('png') === -1 && file.type.indexOf('jpeg') === -1) {
        this.$notify({
          title: '警告',
          message: '只支持jpg格式或png格式图片！',
          type: 'warning'
        })
        return false
      }
      if (file.size / 1024 / 1024 > 3) {
        this.$notify({
          title: '警告',
          message: '请上传3MB以内的图片！',
          type: 'warning'
        })
        return false
      }
      const { data } = await getQiniuToken()
      this.data.token = data.token
      return true
    },
    handleSuccess(res, file, fileList) {
      // this.$emit('get-files', file, fileList)
      this.sendImgs(file, fileList)
    },
    handleError(err) {
      console.log(err, '图片上传出错了')
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleRemove(file, fileList) {
      // this.$emit('get-files', file, fileList)
      this.sendImgs(file, fileList)
    },
    handleExceed() {
      this.$notify({
        title: '警告',
        message: `只能上传${this.length}张图片哦~`,
        type: 'warning'
      })
    },
    sendImgs(file, fileList) {
      const arr = []
      fileList.forEach((item) => {
        // arr.push(item.response.key);
        arr.push(Object.assign({}, item, {
          response: item.response && item.response.key
        }))
      })
      this.$emit('get-files', Object.assign({}, file, {
        response: file.response && file.response.key
      }), arr)
    }
  }
}
</script>

<style lang="scss" scoped>
.hide /deep/ .el-upload--picture-card {
  display: none !important;
}
.updata-img-message {
  font-size: 12px;
  color: #999;
}
.show{
  position: fixed;
  z-index: 999;
}
</style>
